module.exports = __webpack_public_path__ + "static/stitch-8c1bd44a1bc07898b5a3436ae7288882.png";